import _classCallCheck from "/builds/denic-eg/dns/nast/nastng-webui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/builds/denic-eg/dns/nast/nastng-webui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/builds/denic-eg/dns/nast/nastng-webui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/builds/denic-eg/dns/nast/nastng-webui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
export var AddressError = /*#__PURE__*/function (_Error) {
  _inherits(AddressError, _Error);

  var _super = _createSuper(AddressError);

  function AddressError(message, parseMessage) {
    var _this;

    _classCallCheck(this, AddressError);

    _this = _super.call(this, message);
    _this.name = 'AddressError';

    if (parseMessage !== null) {
      _this.parseMessage = parseMessage;
    }

    return _this;
  }

  return AddressError;
}( /*#__PURE__*/_wrapNativeSuper(Error));